import { faTimes } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon, FontAwesomeIconProps } from '@fortawesome/react-fontawesome';
import cx from 'classnames';
import {
    DELETED_REASON,
    POST_IS_DELETED_FIND_WHY__IN_CODEX,
    POST_IS_DELETED_FIND_WHY__READ,
    VISIBILITY_ALERT_OR_LOGIN,
    VISIBILITY_ALERT_REGISTER,
} from 'mk/autogenerated/translations/AnnouncementBox.28c7bf8156e4f5b00b4b72d2859cb0a7'
import { aboutRulesCodexUrl } from 'mk2/apps/about/urls';
import { blogsProfileUrl } from 'mk2/apps/blogs/urls';
import { loginUrl, signupUrl } from 'mk2/apps/users/urls';
import Btn, { BtnLayout, BtnType } from 'mk2/components/Btn';
import Link from 'mk2/components/Link';
import { DeletedByRole } from 'mk2/helpers/deleteable';
import { timeAt } from 'mk2/helpers/timeformat';
import { url } from 'mk2/helpers/urls';
import React from 'react';
import styles from './AnnouncementBox.mscss';

export const BoxType = {
    Deleted: 'deleted' as 'deleted',  // also used for blocked posts (legacy function)
    DeletedMessage: 'deletedMessage' as 'deletedMessage',
    Yellow: 'yellow' as 'yellow',
    NoAuthNoContent: 'noAuthNoContent' as 'noAuthNoContent',
    White: 'white' as 'white',
};
export type BoxType = (typeof BoxType)[keyof typeof BoxType];

export const addSecondLineWithCodexReference = (deletable: { deletedByRole?: DeletedByRole }) =>
    deletable.deletedByRole === DeletedByRole.DeletedByAdmin ? (
        <span>
            <Link to={aboutRulesCodexUrl}>
                {POST_IS_DELETED_FIND_WHY__READ}
            </Link>
            {POST_IS_DELETED_FIND_WHY__IN_CODEX}
        </span>
    ) : undefined;

interface OwnProps {
    message: string;
    secondLine?: React.ReactNode;  // may contain reference on rules-codex
    detailMessage?: React.ReactNode;   // must be string if deletedAt is set
    hasDetailMessage: boolean;
    deletedAt?: string;
    icon?: FontAwesomeIconProps;
    deletedBy?: string;
    type: BoxType;
    currentUrl?: string;

    onClose?();
}

const AnnouncementBox: React.StatelessComponent<OwnProps> = ({
    currentUrl, deletedAt, deletedBy, detailMessage, hasDetailMessage, icon, message, onClose, secondLine,
    type,
}) => (
    <div className={styles.AnnouncementBox}>
        <div className={styles['AnnouncementBox--type-' + type]}>
            <div className={styles['AnnouncementBox__messageWrapper--type-' + type]}>
                {icon && (
                    <div className={styles['AnnouncementBox__icon--type-' + type]}>
                        <FontAwesomeIcon {...icon} />
                    </div>
                )}
                <div className={styles['AnnouncementBox__message--type-' + type]}>
                    {message}
                    {deletedBy && (
                        <span>&nbsp;(
                            <Link
                                className={styles.AnnouncementBox__deletedBy}
                                to={url(blogsProfileUrl, { username: deletedBy })}
                            >
                                {deletedBy}
                            </Link>)
                        </span>
                    )}
                </div>
            </div>
            {secondLine && (
                <div className={styles['AnnouncementBox__detailMessage--type-' + type]}>
                    {secondLine}
                </div>
            )}
            {hasDetailMessage && detailMessage && !deletedAt && (
                <div className={styles['AnnouncementBox__detailMessage--type-' + type]}>
                    {detailMessage}
                </div>
            )}
            {hasDetailMessage && detailMessage && deletedAt && (
                <div className={styles['AnnouncementBox__detailMessage--type-' + type]}>
                    <div><b>{DELETED_REASON}</b>: {detailMessage}</div>
                    <div>{timeAt(deletedAt)}</div>
                </div>
            )}
            {type === BoxType.NoAuthNoContent && (
                <div
                    className={cx(styles['AnnouncementBox__ctaButtons--type-' + type])}
                >
                    <Btn
                        type={BtnType.Blue}
                        link={url(signupUrl, {}, currentUrl && { next: currentUrl })}
                        label={VISIBILITY_ALERT_REGISTER}
                    />
                    &nbsp;
                    <Btn
                        type={BtnType.Link}
                        link={url(loginUrl, {}, currentUrl && { next: currentUrl })}
                        label={VISIBILITY_ALERT_OR_LOGIN}
                    />
                </div>
            )}
            {onClose && (
                <Btn
                    className={cx(styles.AnnouncementBox__closeButton, styles['AnnouncementBox__closeButton--type-' + type])}
                    layout={BtnLayout.Icon}
                    icon={faTimes}
                    onClick={onClose}
                />
            )}
        </div>
    </div>
);

export default AnnouncementBox;
